import { render, staticRenderFns } from "./InfoAccessorials.vue?vue&type=template&id=66288134&scoped=true"
import script from "./InfoAccessorials.vue?vue&type=script&lang=js"
export * from "./InfoAccessorials.vue?vue&type=script&lang=js"
import style0 from "./InfoAccessorials.vue?vue&type=style&index=0&id=66288134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66288134",
  null
  
)

export default component.exports